// トップページ：新着タイルの Ajax 読み込み + ジャスティファイド・タイルレイアウト
import imagesLoaded from 'imagesloaded';

const isSp = () => window.matchMedia('(max-width:1039px)').matches;
const tilesEl = () => document.getElementById('tiles');

let page = 0;
let window_width = null;

const loadNextPage = () => {
  const tiles = tilesEl();
  if (!tiles) return;
  tiles.classList.add('loading');
  page++;

  fetch(`/?tiles_page=${page}`, { cache: 'no-store' })
    .then((r) => r.json())
    .then((res) => {
      if (!res.data) {
        console.error("Can't recieve data");
        return;
      }
      tiles.insertAdjacentHTML('beforeend', res.data);
      tiles.classList.remove('loading');
      // 画像が読み込まれ高さが確定してから配置
      imagesLoaded(tiles, () => {
        document.body.removeAttribute('data-first_tile_loading');
        new TilingManager(true);
      });
      if (res.the_last) {
        const readmore = document.getElementById('readmore');
        if (readmore) readmore.remove();
      }
    });
};

// IE 対策で load はトップレベルに
window.addEventListener('load', () => {
  loadNextPage();
  window_width = window.innerWidth;
});

document.addEventListener('DOMContentLoaded', () => {
  let resizeTimer = null;
  const info = document.getElementById('info');
  const margin = 30;

  // info の表示/非表示。transition（duration/easing/フェード）は CSS #info / #info.is-visible に集約。
  // JS は .is-visible の付け外しと display 制御のみ（値の二重定義をしない）。
  const show = (el) => {
    el.style.display = 'block';
    // display 反映後に opacity/位置を遷移させる
    requestAnimationFrame(() => el.classList.add('is-visible'));
  };
  const hide = (el) => {
    el.classList.remove('is-visible');
  };
  if (info) {
    // フェードアウト完了後にレイアウトから外す（duration を JS に持たせず transitionend で判定）
    info.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'opacity' && !info.classList.contains('is-visible')) {
        info.style.display = 'none';
      }
    });
  }

  document.addEventListener('mouseover', (e) => {
    const tile = e.target.closest('.tile');
    if (tile && info && !isSp()) {
      const text = tile.querySelector('.text');
      if (text) {
        info.innerHTML = text.innerHTML;
        show(info);
      }
    }
  });
  document.addEventListener('mouseout', (e) => {
    const tile = e.target.closest('.tile');
    // タイルから完全に出たときのみ
    if (tile && info && !isSp() && !tile.contains(e.relatedTarget)) {
      hide(info);
    }
  });

  // info のカーソル追従
  const contents = document.getElementById('contents');
  if (contents && info) {
    contents.addEventListener('mousemove', (e) => {
      if (isSp()) return;
      const wrap = document.querySelector('#contents>.wrap');
      if (!wrap) return;
      const top = e.pageY + margin;
      const areaMin = wrap.getBoundingClientRect().left + window.scrollX;
      const areaMax = window.innerWidth;
      const percentage = (e.pageX - areaMin) / (areaMax - areaMin);
      const min = margin;
      const max = wrap.offsetWidth - info.offsetWidth - margin;
      const left = min + (max - min) * percentage;
      info.style.left = `${left}px`;
      info.style.top = `${top}px`;
    });
  }

  // read more
  document.addEventListener('click', (e) => {
    if (e.target.closest('#readmore')) {
      e.preventDefault();
      loadNextPage();
    }
  });

  // resize
  window.addEventListener('resize', () => {
    const tiles = tilesEl();
    if (!tiles) return;
    if (isSp()) {
      document.querySelectorAll('.tile').forEach((t) => t.removeAttribute('style'));
    } else {
      const current = window.innerWidth;
      if (window_width !== current) {
        tiles.classList.add('resizing');
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          tiles.classList.remove('resizing');
          new TilingManager();
        }, 500);
      }
      window_width = current;
    }
  });
});

class TilingManager {
  constructor(do_not_init = false) {
    this.rows = [];
    if (!do_not_init) this._init();
    if (isSp()) {
      this._adjustAspectRatio();
    } else {
      this._adjustRowHeight();
    }
  }

  _init() {
    const tiles = Array.from(document.querySelectorAll('.tile'));
    tiles.forEach((t) => {
      t.setAttribute('data-calc', 'false');
      t.removeAttribute('style');
    });
    // data-index 順に並び替えて再追加
    tiles.sort((a, b) => {
      const an = parseInt(a.getAttribute('data-index'), 10);
      const bn = parseInt(b.getAttribute('data-index'), 10);
      return an - bn;
    });
    const container = tilesEl();
    tiles.forEach((t) => container.appendChild(t));
  }

  _adjustRowHeight() {
    const tiles = Array.from(document.querySelectorAll('.tile[data-calc="false"]'));
    const throughs = tiles.filter((t) => t.classList.contains('through'));
    const not_throughs = tiles.filter((t) => !t.classList.contains('through'));

    let row = this._createRow();
    not_throughs.forEach((el) => {
      if (row.checkSpace(el)) {
        row.add(el);
      } else {
        this._regist(row);
        row = this._createRow();
        row.add(el);
      }
    });
    if (row.length) this._regist(row);

    // .through を行グルーピングを跨がないように移動 + rows に登録
    throughs.forEach((el) => {
      const isLast = el === el.parentNode.lastElementChild;
      if (el === tiles[0] || isLast) {
        // 先頭/末尾の through は rows に登録しない（CSS で全幅。高さ調整不要）
        const r = this._createRow(true);
        r.add(el);
      } else {
        const index = parseInt(el.getAttribute('data-index'), 10);
        const res = this._searchInsertPositionOfThrough(index);
        if (res) {
          const ref = document.querySelector(`.tile[data-index="${res.domIndex}"]`);
          if (ref) ref.after(el);
          const r = this._createRow(true);
          r.add(el);
          this._insert(res.rowIndex, r);
        }
      }
    });

    // 最後の行に :not(.through) が1つだけ余ったら前の行へ押し込む
    const the_last_row = this.rows[this.rows.length - 1];
    if (the_last_row && the_last_row.length === 1 && !the_last_row.through) {
      this.rows.pop();
      const res = this._searchPositionOfLastNotThroughRow();
      if (res) {
        const ref = document.querySelector(`.tile[data-index="${res.domIndex}"]`);
        if (ref) ref.after(the_last_row.first);
        this.rows[res.rowIndex].add(the_last_row.first, true);
      }
    }

    this.rows.forEach((r) => r.adjust());

    if (!isSp()) {
      tiles.forEach((el, index) => {
        el.style.transitionDelay = `${0.1 * index + Math.random() * 0.6}s`;
      });
      setTimeout(() => {
        tiles.forEach((el) => { el.style.transitionDelay = ''; });
      }, 5000);
    }

    tiles.forEach((el) => el.setAttribute('data-calc', 'true'));
  }

  // 高さが幅の1.3以上のものをマーク（SP）
  _adjustAspectRatio() {
    document.querySelectorAll('.tile').forEach((tile) => {
      if (tile.querySelector('img.sp')) {
        tile.setAttribute('data-calc', 'true');
        return;
      }
      const img = tile.querySelector('img');
      if (img && img.offsetWidth) {
        const ratio = img.offsetHeight / img.offsetWidth;
        if (ratio >= 1.3) tile.setAttribute('data-tatenaga', 'true');
      }
      tile.setAttribute('data-calc', 'true');
    });
  }

  _regist(item) { this.rows.push(item); }
  _insert(index, item) { this.rows.splice(index, 0, item); }
  _createRow(through = false) { return new Row(through); }

  _searchInsertPositionOfThrough(index) {
    let res = null;
    let i = 0;
    this.rows.some((row) => {
      if (index < row.lastIndex) {
        res = { rowIndex: i + 1, domIndex: row.lastIndex };
        return true;
      }
      i++;
      return false;
    });
    return res;
  }

  _searchPositionOfLastNotThroughRow() {
    let res = null;
    let i = 0;
    this.rows.slice().reverse().some((row) => {
      if (!row.through) {
        res = { rowIndex: this.rows.length - i - 1, domIndex: row.lastIndex };
        return true;
      }
      i++;
      return false;
    });
    return res;
  }
}

class Row {
  constructor(through = false) {
    this.maxWidth = tilesEl().clientWidth;
    this.items = [];
    this.through = through;
  }
  get length() { return this.items.length; }
  get totalWidth() {
    return this.items.reduce((sum, item) => sum + item.offsetWidth, 0);
  }
  get first() { return this.items[0]; }
  get last() { return this.items[this.length - 1]; }
  get lastIndex() { return parseInt(this.last.getAttribute('data-index'), 10); }

  add(item, force = false) {
    if (force || this.checkSpace(item)) {
      this.items.push(item);
    } else {
      console.error('Row is full!');
    }
  }
  checkSpace(item) {
    return item.offsetWidth <= this.maxWidth - this.totalWidth;
  }
  adjust() {
    // through タイルは border-right: 0、それ以外は 1px → sum(offsetWidth) が maxWidth を超えないよう補正
    const borderPerTile = this.through ? 0 : 1;
    const magnification = (this.maxWidth - this.items.length * borderPerTile) / this.totalWidth;
    this.items.forEach((item) => {
      const w = Math.floor(item.offsetWidth * magnification);
      const h = Math.floor(item.offsetHeight * magnification);
      item.style.width = w + 'px';
      item.style.height = h + 'px';
    });
  }
}
